/* eslint-disable consistent-return */
import getArrayIndices from '../common/getStateArrayIndices';
import swapArrayItems from '../common/swapArrayItems';

export default {
    mergeColumn: (state, action) => {
        const { blockIndex, columnIdx, direction } = action.payload;
        const block = state.find((foundBlock) => foundBlock.index === blockIndex);
        const mergingColumnSize = block.content.columns.find((col) => col.columnIdx === columnIdx).size;
        const { blockArrIdx, columnArrIdx } = getArrayIndices(state, blockIndex, columnIdx);
        if (direction === 'left' && columnArrIdx === 0) {
            return state;
        }
        if (direction === 'right' && columnArrIdx === block.content.columns.size - 1) {
            return state;
        }
        const mergedColumnIdx = (direction === 'left') ? columnArrIdx - 1 : columnArrIdx + 1;
        const mergedColumnSize = block.content.columns[mergedColumnIdx].size;
        const newSize = mergingColumnSize + mergedColumnSize;
        state[blockArrIdx].content.columns[columnArrIdx].size = newSize;
        state[blockArrIdx].content.columns.splice(mergedColumnIdx, 1);
        state[blockArrIdx].content.columnNum = state[blockArrIdx].content.columns.length;
    },

    moveColumn: (state, action) => {
        const { blockIndex, columnIdx, direction } = action.payload;
        const { blockArrIdx, columnArrIdx } = getArrayIndices(state, blockIndex, columnIdx);
        const swappingColumnArrIdx = (direction === 'left') ? columnArrIdx - 1 : columnArrIdx + 1;
        swapArrayItems(state[blockArrIdx].content.columns, columnArrIdx, swappingColumnArrIdx);
    },

    splitColumn: (state, action) => {
        const { blockIndex, columnIdx, indices } = action.payload;
        const { blockArrIdx, columnArrIdx } = getArrayIndices(state, blockIndex, columnIdx);
        const column = state[blockArrIdx].content.columns.find((col) => col.columnIdx === columnIdx);
        column.size /= 2;
        const newColumn = {
            ...column,
            columnIdx: indices.column[1],
            columnItems: column.columnItems.map((elm, elmIdx) => ({
                ...elm,
                elmIdx: indices.element[elmIdx],
            })),
        };
        state[blockArrIdx].content.columns.splice(columnArrIdx, 0, newColumn);
        state[blockArrIdx].content.columnNum = state[blockArrIdx].content.columns.length;
    },

    updateColumnSizing: (state, action) => {
        const { newValue, blockID } = action.payload;
        const borderArray = [0, ...newValue, 100];
        const block = state.find((foundBlock) => foundBlock.index === blockID);
        block.content.columns.forEach((column, index) => {
            const nextValue = borderArray[index + 1];
            if (nextValue) {
                column.size = (nextValue - borderArray[index]) / 100;
            }
        });
    },
};
